import {safeDefineElement} from "@/scripts/core/global";
import { CartDrawer } from '@/scripts/cart/CartDrawer';
import { CartRemoveButton } from '@/scripts/cart/CartRemoveButton';
import { CartDrawerItems } from '@/scripts/cart/CartDrawerItems';
import { CartShippingBar } from '@/scripts/cart/CartShippingBar';
import { ProductTabs } from '@/scripts/product/ProductTabs'
import { BlueBird } from '@/scripts/product/BlueBird'
import { ProductForm } from '@/scripts/product-form-context/ProductForm'
import { ProductFormStep } from '@/scripts/product-form-context/ProductFormStep'
import { MediaGallery } from '@/scripts/product-form-context/MediaGallery'
import { ProductSubscribe } from '@/scripts/product-form-context/ProductSubscribe'
import { VariantRadios } from '@/scripts/product-form-context/VariantRadios'
import { StickyCta } from '@/scripts/product-form-context/StickyCta'
import { WaitlistPopup } from '@/scripts/product-form-context/WaitlistPopup'
import { ProductFormContext } from '@/scripts/product-form-context/ProductFormContext'
import { ProductQuiz } from '@/scripts/product-form-context/ProductQuiz'
import { DeferredMedia } from '@/scripts/global/DeferredMedia'
import { DetailsModal } from '@/scripts/global/DetailsModal'
import { ExpandableContent } from '@/scripts/global/ExpandableContent'
import { KlaviyoEmail } from '@/scripts/global/KlaviyoEmail'
import { ShowMoreButton } from '@/scripts/global/ShowMoreButton'
import { ToggleModal } from '@/scripts/global/ToggleModal'
import { QuantityInput } from '@/scripts/product/QuantityInput'
import { JunipItemImage } from '@/scripts/product/JunipItemImage'
import { JunipItemVideo } from '@/scripts/product/JunipItemVideo'
import {
	JunipContainerMedia,
	JunipContainerText,
	JunipPrimaryContainer,
	JunipReviewForm,
	// JunipItemImage,
} from '@/scripts/product/Junip'
import { JunipMediaModal } from "@/scripts/product/JunipMediaModal";


safeDefineElement(CartRemoveButton)
safeDefineElement(CartDrawer)
safeDefineElement(CartDrawerItems)
safeDefineElement(CartShippingBar)
safeDefineElement(ProductTabs)
safeDefineElement(BlueBird)
safeDefineElement(MediaGallery)
safeDefineElement(ProductQuiz)
safeDefineElement(ProductForm)
safeDefineElement(ProductFormStep)
safeDefineElement(ProductSubscribe)
safeDefineElement(VariantRadios)
safeDefineElement(StickyCta)
safeDefineElement(WaitlistPopup)
safeDefineElement(ProductFormContext)
safeDefineElement(DeferredMedia)
safeDefineElement(DetailsModal)
safeDefineElement(ExpandableContent)
safeDefineElement(KlaviyoEmail)
safeDefineElement(ShowMoreButton)
safeDefineElement(ToggleModal)
safeDefineElement(QuantityInput)
safeDefineElement(JunipPrimaryContainer)
safeDefineElement(JunipContainerText)
safeDefineElement(JunipContainerMedia)
safeDefineElement(JunipReviewForm)
// safeDefineElement(JunipItemImage)

// TODO: needs to be updated to use pattern above with uscoast element
customElements.define('junip-item-image', JunipItemImage);
customElements.define('junip-item-video', JunipItemVideo);
customElements.define('junip-media-modal', JunipMediaModal);

